module.exports = __webpack_public_path__ + "static/media/team-spelling.2c726dbe.png";